module.exports = __webpack_public_path__ + "images/down-arrow-e2b8346b.svg";